<div class="container">
  @if (
    (orderListWrapper$ | async) !== undefined &&
    (orderListWrapper$ | async)?.status === "READY"
  ) {
    <table
      mat-table
      [dataSource]="visibleOrderList((orderListWrapper$ | async)?.orderList) || []"
      class="mat-elevation-z8"
    >
      <ng-container matColumnDef="internalOrderNumber">
        <th class="table-header" mat-header-cell *matHeaderCellDef>Edit</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          @if (!order.subrental) {
            @if (this.loadingOrderId !== order.internalOrderNumber) {
              <mat-icon class="edit-icon" (click)="redirectToEdit(order)"
                >edit_document</mat-icon
              >
            } @else {
              <div
                style="
                  min-width: 100%;
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                "
              >
                <mat-spinner diameter="15"></mat-spinner>
              </div>
            }
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="tracking">
        <th class="table-header" mat-header-cell *matHeaderCellDef>Track</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          @if (orderHasShippingStatus(order.details)) {
            <mat-icon class="edit-icon" (click)="openModal(order)"
              >local_shipping</mat-icon
            >
          } @else {}
        </td>
      </ng-container>

      <ng-container matColumnDef="receipt">
        <th class="table-header" mat-header-cell *matHeaderCellDef>Receipt</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          @if (!order.subrental) {
            <mat-icon
              [ngClass]="setReceiptClass(order)"
              class="edit-icon"
              (click)="redirectToReceipt(order)"
              >receipt</mat-icon
            >
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="eventDate">
        <th
          class="table-header"
          mat-header-cell
          *matHeaderCellDef
          [class.sorted]="sortKey() === 'eventDate'"
          (click)="sortBy('eventDate')"
        >
          Date
          @if (sortKey() === "eventDate") {
            <span class="sort-arrow">{{ sortDirection() === 1 ? "↑" : "↓" }}</span>
          }
        </th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          {{ order.eventDate | date: "MM/dd/yy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="orderNumber">
        <th
          class="table-header"
          mat-header-cell
          *matHeaderCellDef
          [class.sorted]="sortKey() === 'orderNumber'"
          (click)="sortBy('orderNumber')"
        >
          #
          @if (sortKey() === "orderNumber") {
            <span class="sort-arrow">{{ sortDirection() === 1 ? "↑" : "↓" }}</span>
          }
        </th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          @if (!order.subrental) {
            {{ order.orderNumber }}
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="customer">
        <th
          class="table-header"
          mat-header-cell
          *matHeaderCellDef
          [class.sorted]="sortKey() === 'customer'"
          (click)="sortBy('customer')"
        >
          Customer
          @if (sortKey() === "customer") {
            <span class="sort-arrow">{{ sortDirection() === 1 ? "↑" : "↓" }}</span>
          }
        </th>

        <td class="table-cell" mat-cell *matCellDef="let order; let i = index">
          @for (seg of highlightSegments(order.fullName, filterTerm()); track $index) {
            @if (seg.match) {
              <mark>{{ seg.text }}</mark>
            } @else {
              {{ seg.text }}
            }
          }
          <div class="condition-badges">
            @if (hasReplacement(order)) {
              <!-- matTooltip="{{ getReplacementToolTip(order) }}" -->
              <app-custom-tooltip
                [tooltipText]="getReplacementToolTip(order)"
                position="bottom"
                backgroundColor="var(--surface-tooltip, #f6f6f6)"
                textColor="var(--text-body, #000000)"
                minWidth="200px"
              >
                <div class="hover-info-text">Replacement</div>
              </app-custom-tooltip>
            }
            @if (hasDirectDelivery(order)) {
              <app-custom-tooltip
                [tooltipText]="getDirectDelieveryToolTip(order)"
                position="bottom"
                backgroundColor="var(--surface-tooltip, #f6f6f6)"
                textColor="var(--text-body, #000000)"
                minWidth="250px"
                textAlign="center"
              >
                <div class="hover-info-text">Direct Delivery</div>
              </app-custom-tooltip>
            }
            @if (order.subrental) {
              <p class="subrental">
                Subrental {{ order.warehouseOrderHeader }}
              </p>
            }
            @if (!order.subrental && order.shipToCode === 2) {
              <app-custom-tooltip
                [tooltipText]="getShipToDiffActToolTip(order)"
                position="bottom"
                backgroundColor="var(--surface-tooltip, #f6f6f6)"
                textColor="var(--text-body, #000000)"
                minWidth="250px"
                textAlign="center"
              >
                <p class="subrental">Ship To Diff Acct</p>
              </app-custom-tooltip>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="eventDescription">
        <th
          class="table-header"
          mat-header-cell
          *matHeaderCellDef
          [class.sorted]="sortKey() === 'eventDescription'"
          (click)="sortBy('eventDescription')"
        >
          Event
          @if (sortKey() === "eventDescription") {
            <span class="sort-arrow">{{ sortDirection() === 1 ? "↑" : "↓" }}</span>
          }
        </th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          @if (
            this.loadingEventId === order.nationalEventId &&
            order.internalOrderNumber === this.loadingOrderNumber
          ) {
            <div
              style="
                min-width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: center;
              "
            >
              <mat-spinner diameter="15"></mat-spinner>
            </div>
          } @else {
            <a (click)="this.redirectToEventManager(order)">
              @for (seg of highlightSegments(order.eventDescription, filterTerm()); track $index) {
                @if (seg.match) {
                  <mark>{{ seg.text }}</mark>
                } @else {
                  {{ seg.text }}
                }
              }
            </a>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="orderType">
        <th
          class="table-header"
          mat-header-cell
          *matHeaderCellDef
          [class.sorted]="sortKey() === 'orderType'"
          (click)="sortBy('orderType')"
        >
          Type
          @if (sortKey() === "orderType") {
            <span class="sort-arrow">{{ sortDirection() === 1 ? "↑" : "↓" }}</span>
          }
        </th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          {{ order.orderType }}
        </td>
      </ng-container>

      <ng-container matColumnDef="caller">
        <th class="table-header" mat-header-cell *matHeaderCellDef>Caller</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          {{ order.callerName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="accountNumber">
        <th class="table-header" mat-header-cell *matHeaderCellDef>
          Account #
        </th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          {{ order.orderAccountNumber }}
        </td>
      </ng-container>

      <ng-container matColumnDef="accountName">
        <th class="table-header" mat-header-cell *matHeaderCellDef>
          Account Name
        </th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          @for (seg of highlightSegments(order.shipToName, filterTerm()); track $index) {
            @if (seg.match) {
              <mark>{{ seg.text }}</mark>
            } @else {
              {{ seg.text }}
            }
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="city">
        <th class="table-header" mat-header-cell *matHeaderCellDef>City</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          {{ order.shipToCity }}
        </td>
      </ng-container>

      <ng-container matColumnDef="state">
        <th class="table-header" mat-header-cell *matHeaderCellDef>State</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          {{ order.shipToState }}
        </td>
      </ng-container>

      <!-- ======================================================================= -->

      <ng-container matColumnDef="nationalEventId">
        <th class="table-header" mat-header-cell *matHeaderCellDef>
          National Event Id
        </th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          {{ order.nationalEventId }}
        </td>
      </ng-container>

      <ng-container matColumnDef="productionWeek">
        <th class="table-header" mat-header-cell *matHeaderCellDef>PWeek</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          {{ order.productionWeek }}
        </td>
      </ng-container>

      <ng-container matColumnDef="eventAccount">
        <th class="table-header" mat-header-cell *matHeaderCellDef>
          Event Account
        </th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          {{ order.eventAccount }}
        </td>
      </ng-container>

      <tr
        class="table-header-row"
        [class.sticky-header]="stickyHeaderStackAbove()"
        [jfwStickyStackTop]="stickyHeaderStackAbove()"
        mat-header-row
        *matHeaderRowDef="displayedColumns"
      ></tr>
      <tr
        class="default-row"
        [ngClass]="{ 'alt-row': i % 2 === 1 }"
        mat-row
        *matRowDef="let row; let i = index; columns: displayedColumns"
      ></tr>
    </table>

    <div class="pagination-footer">
      @if (hasMore((orderListWrapper$ | async)?.orderList)) {
        <button type="button" class="load-more-button" (click)="loadMore()">
          Load 50 more
        </button>
      }
      <span class="end-label">{{ endLabel((orderListWrapper$ | async)?.orderList) }}</span>
    </div>
  } @else if (
    loaded() &&
    !error() &&
    receivedOrderList !== undefined &&
    receivedOrderList.length === 0
  ) {
    <div>No orders found</div>
  } @else if (error()) {
    <!-- <mat-error>Error loading orders</mat-error> -->
  }
</div>
